/**
 * A super module that collects available sub-modules.
 * 
 * @namespace vef.ui.slider
 * @memberof vef.ui
 */

export * from './Slider.js';
export * from './SliderHeader.js';
export * from './TimeSlider.js';